// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum enumName_searching {
  FilterDateRangeType = "FilterDateRangeType",
}
